<template>
    <ul class="submenu-sections">
        <router-link v-if="isSmartBox" tag="li" :to="{name:'SmartBoxFilters', params:$route.params}">
            <a>
                <h4><span class="text">Filters</span></h4>
            </a>
        </router-link>
        <router-link tag="li" :to="{name:'BoxDetails', params:$route.params}">
            <a>
                <h4><span class="text">Tracks</span></h4>
            </a>
        </router-link>

<!--        <router-link tag="li" :to="{name:'SmartBoxSources', params:$route.params}">-->
<!--            <a>-->
<!--                <h4><span class="text">Sources</span></h4>-->
<!--            </a>-->
<!--        </router-link>-->
        <!-- <router-link tag="li" :to="{name:'BoxBasic', params:$route.params}">
            <a>
                <h4><span class="text">Edit</span></h4>
            </a>
        </router-link> -->
        <router-link tag="li" :to="{name:'BoxConstraints', params:$route.params}">
            <a>
                <h4><span class="text">Constraints</span></h4>
            </a>
        </router-link>
        <router-link tag="li" :to="{name:'BoxBranding', params:$route.params}">
            <a>
                <h4><span class="text">Branding</span></h4>
            </a>
        </router-link>
    </ul>

</template>

<script>
    import router from '@/router'
    import {mapState} from "vuex";
    export default {
        name: "LibraryMenu",
        router,
        watch: {
            '$route' () {
                this.$forceUpdate();
            }
        },
        computed: {
            ...mapState({
                currentBox: state => state.currentBox,
            }),
            isSmartBox() {
                return this.currentBox && this.currentBox.type === 'SMARTBOX'
            }
        }
    }
</script>

<style scoped>
</style>
